<app-page-list [columns]="columns" [queryService]="service.query" [canInsert]="false" [canShowDetail]="false"></app-page-list>
